import { useMemo, VFC } from 'react';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { useParams } from 'react-router-dom';
import { MeterContext } from 'contexts/Meter';
import { FormattedMessage } from 'react-intl';
import { useContextMeter } from 'hooks/useContextMeter';
import { Layout } from '../../components/Layout/Layout';
import { ServiceInspectionContent } from './components/Content';
import { ServiceInspectionFooter } from './components/Footer';
import { ServiceInspection as messages } from './messages';

export const ServiceInspectionPage: VFC = () => {
  const { id: inventoryMeterId } = useParams();

  const toolsId = parseInt(inventoryMeterId ?? '');
  const { enmonMeter, inventoryMeter, isLoading } = useContextMeter(toolsId);

  const contextValue = useMemo(
    () => ({ enmonMeter, inventoryMeter, isLoading }),
    [enmonMeter, inventoryMeter, isLoading],
  );

  return (
    <MeterContext.Provider value={contextValue}>
      <Layout
        footerContent={<ServiceInspectionFooter />}
        headerContent={<FormattedMessage {...messages.headerContent} />}
        progressBarContent={null}
      >
        {isLoading ? <LoadingSpinner /> : <ServiceInspectionContent />}
      </Layout>
    </MeterContext.Provider>
  );
};
